Vendd.Scripts.load(function () {

    $('.x-photogallery.x-photogallery-carousel.document-gallery').each(function (i, wrapper) {
        if (!$(wrapper).data('init'))
            return;

        var $wrapper = $(wrapper);
        var $normalWrapper = $('> ul', $wrapper);

        var fbOpts = {
            protect: true,
            infobar: true
        };
       
        initCarousel($normalWrapper[0]);
        $('.fancylink', $wrapper).fancybox(fbOpts);
                  
    });

    function initCarousel(items) {
        var carousel = $(items);

        var opts = {
            slidesToShow: 1,
            slidesToScroll:1,
            dots: true,
            infinite: false,
            variableWidth: true,
            draggable: false,
            nextArrow: $('.x-photogallery-carousel .nav-next'),
            prevArrow: $('.x-photogallery-carousel .nav-prev'),
            responsive: [
                {
                    breakpoint: 740,
                    settings: {
                        variableWidth: false
                    }
                }
            ]
        }

        carousel.on('init', function (event, slick) {
            $('li.slick-cloned > a', carousel).removeAttr('data-fancybox');
        });

        carousel.slick(opts);

    }
});